<template>
   <div class="informationxm">
                <div class="form_wrapper">
                  <!-- <div class="form_header">
                    <div class="form_header_name">{{title}}</div>
                    <div class="form_header_remarks"></div>
                  </div> -->
                  <avue-crud :option="option" :data="itemDate" :header-cell-class-name="headerClassName">
                      <template slot="name" slot-scope="{ row }" >
                      <router-link  class="linkcolor" :to='"/fund/subFundNew/fundDetail/"+row.id'>{{row.name}}</router-link> 
                      </template>
                    <template slot="projectName" slot-scope="{ row }" >
                        <router-link class="linkcolor" :to='{
                         path: "/fund/fundProjectManage/detail",
                         query:{id:row.id}
                        }'>{{row.projectName}}</router-link>
                         
                      </template>
                      <template slot="fundName" slot-scope="{ row }" >
                        <router-link class="linkcolor" :to='{
                         path: "/fund/subFundNew/fundDetail/"+row.id,
                        }'>{{row.fundName}}</router-link>
                         
                      </template>
                      <template slot="eventName" slot-scope="{ row }" >
                        <router-link class="linkcolor" :to='{
                         path: `/fund/investEventManage/detail/${row["id"]}`,
                         query:{eventType: row["eventType"]}
                        }'>{{row.eventName}}</router-link>
                         
                      </template>
                        <template slot="custName" slot-scope="{ row, }" >
                        <router-link class="linkcolor" :to='"/zd/customer/detail/"+row.custBasicInfoId'>{{row.custName}}</router-link>
                      </template>
                  </avue-crud>
                </div>
              </div>
</template>

<script>
export default {
data(){
    return {}
},
watch:{
    itemDate:{
        deep:true,
        handler(){
            
        }
    }
},
created(){
},
props:{
    option:Object,
     itemDate:{typeof:JSON, default:[]} ,
     title:String,
},methods: {
    headerClassName(tab){
       
      return 'avue_bgc';
    },
  }
}
</script>

<style lang="scss" scoped>
.linkcolor{
  color: #409EFF;
  text-decoration:underline;
}
/deep/.el-table__header-wrapper{
  th{
    font-size: 14px;
  }
}
/deep/ .el-table__body-wrapper{
  th{
    font-size: 14px !important;
  }
  span{
    font-size: 14px !important;
  }
}
.form_wrapper {
  height: 100%;
  margin: 0;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border: 1px solid rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);

    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 14px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.checkcontract {
  cursor: pointer;
}
.detil_row {
  display: inline-block;
}
/deep/.el-table__header{
  width: 100% !important;
}
/deep/.el-table__body{
  width: 100% !important;
}
/deep/.el-table__empty-block{
  width: 100% !important;
}
/deep/.el-form-item__label {
  color: #999999;
}
/deep/.el-tabs__header {
  margin: 0px;
}
.informationxm {
  margin-top: 20px;
}
/deep/.avue-crud__menu {
  display: none;
}
/deep/.avue-crud {
  width: 100%;
}
/deep/.avue-crud .el-table th {
  background-color: #ffffff;
  line-height: 50px;
  padding: 0;
}
/deep/.el-table .cell,
.el-table th > .cell {
  padding-left: 20px;
}
/deep/.el-table__empty-block {
  border-right: none;
}
/deep/ .el-table {
    border-color: #e0eeff;
}
/deep/.avue_bgc{
  background: #F6FAFF !important;
  font-weight: 400 !important;
}
</style>